export const emailButtonDataCy = 'email_button_login';
export const amazonButtonDataCy = 'amazon_button_login';

export const AMAZON_AUTH_URL = 'https://mybites-2.idp.amazon-corp.com/';
